import {
  ADMIN_LDAP_GROUP,
  ENGINEER_LDAP_GROUP,
  VLM_AUDITOR_LDAP_GROUP,
  VLM_BETA_TESTER_ALIASES,
} from "src/constants";
import { Model } from "src/store/modelManagementSlice";

export const isAdminUser = (ldap: string[]): boolean => {
  return ldap.includes(ADMIN_LDAP_GROUP) || ldap.includes(ENGINEER_LDAP_GROUP);
};

// TEMPORARY beta-tester guard for the VLM Audit entry point (header tab + route).
// At launch this is removed and the AuditPermissionMember table (GET /audit_access/me
// -> isMember) becomes the only entry gate.
export const canAccessVlmAudit = (ldap: string[], alias: string): boolean => {
  return ldap.includes(VLM_AUDITOR_LDAP_GROUP) || VLM_BETA_TESTER_ALIASES.includes(alias);
};

export const isProd = (): boolean => {
  const stage: string = "beta";
  return stage.toLowerCase() === "prod";
};

/**
 * Checks if a user has permission to access a model
 * @param model The model to check permissions for
 * @param userAlias The user's alias
 * @param userLdap The user's LDAP groups
 * @returns boolean indicating if the user has permission
 */
export const hasModelPermission = (
  model: Model,
  userAlias: string,
  userLdap: string[],
): boolean => {
  // Admin users always have permission
  if (isAdminUser(userLdap)) {
    return true;
  }

  // Model owner always has permission
  if (model.ownerAlias && model.ownerAlias === userAlias) {
    return true;
  }

  // Check if user has explicit permission in any permission group
  if (model.permissions) {
    for (const permissionGroup of Object.values(model.permissions)) {
      // Handle both Set and Array types
      if (Array.isArray(permissionGroup)) {
        // Case-insensitive check for user alias in array
        if (permissionGroup.some((alias) => alias.toLowerCase() === userAlias.toLowerCase())) {
          return true;
        }
      } else if (permissionGroup instanceof Set) {
        // Case-insensitive check for user alias in Set
        let hasPermission = false;
        permissionGroup.forEach((alias) => {
          if (alias.toLowerCase() === userAlias.toLowerCase()) {
            hasPermission = true;
          }
        });
        if (hasPermission) {
          return true;
        }
      }
    }
  }

  // No permission found
  return false;
};
